import api from "@services/api";
import apiNotification from "@services/apiNotification";
import axios from "axios";
import * as signalR from "@microsoft/signalr";

interface IMarkViewed {
  tipoNotificacao: number;
  Id: string;
}

interface IMarkDisplayed {
  idsNotificacaoNovaOp: string[];
  idsNotificacaoRetornoAC: string[];
  idsNotificacaoRetornoCotacao: string[];
}

class NotifyService {
  private connection: signalR.HubConnection | null = null;

  /**
   * Conecta ao SignalR
   */
  async connect(
    usuarioId: string,
    onMessage: (data: any) => void,
    onListUpdate?: (lista: any[]) => void,
  ) {
    // Se já existe uma conexão, desconecta antes de tentar nova conexão.
    if (
      this.connection &&
      this.connection.state !== signalR.HubConnectionState.Disconnected
    ) {
      console.warn("SignalR já está conectado. Desconectando...");
      await this.disconnect();
    }

    function handleUrl() {
      if (
        window.location.href.includes("localhost") ||
        window.location.href.includes(":3000")
      )
        return "https://backend-dev-eks.boravender.app.br/Regras";

      if (window.location.href.includes("dev"))
        return "https://backend-dev-eks.boravender.app.br/Regras";

      if (window.location.href.includes("qa"))
        return "https://backend-qa-eks.boravender.app.br/Regras";

      if (window.location.href.includes("stage"))
        return "https://bestage.direcional.com.br/bora-vender/v1";

      return "https://backend-prod-eks.boravender.app.br/Regras";
    }

    this.connection = new signalR.HubConnectionBuilder()
      .withUrl(`${handleUrl()}/notificacaohub?usuario=${usuarioId}`)
      .withAutomaticReconnect()
      .configureLogging(signalR.LogLevel.Warning)
      .build();

    // Evento de notificação individual
    this.connection.on("ReceberNotificacao", (data) => {
      onMessage(data);
    });

    // Evento de lista atualizada
    this.connection.on("ReceberListaNotificacoes", (lista) => {
      if (onListUpdate) {
        onListUpdate(lista);
      }
    });

    try {
      await this.connection.start();
      console.log("Conectado ao SignalR");
    } catch (err) {
      console.error("Erro ao conectar SignalR:", err);
    }
  }

  async disconnect() {
    if (
      this.connection &&
      this.connection.state !== signalR.HubConnectionState.Disconnected
    ) {
      await this.connection.stop();
      this.connection = null;
      console.log("Conexão com SignalR fechada");
    } else {
      this.connection = null;
    }
  }

  async getNotify() {
    const access_token = localStorage.getItem("@tokenNotification");

    try {
      const response = await api.get("/notificacao/obter", {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      });

      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return error.response;
      }
      return false;
    }
  }

  async markViewed({ tipoNotificacao, Id }: IMarkViewed) {
    try {
      const response = await api.patch(
        "/notificacao/marcar-visualizada",
        {},
        {
          params: {
            tipoNotificacao,
            Id,
          },
        },
      );

      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return error.response;
      }
    }
  }

  async markDisplayed(data: IMarkDisplayed) {
    try {
      const response = await api.patch("/notificacao/marcar-exibido", data);

      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return error.response;
      }
    }
  }
}

const notifyServiceInstance = new NotifyService();
export default notifyServiceInstance;
